import { ADMIN, DOCTOR, SUPER_ADMIN } from './roles';

/**
 * The staff log (Log history page): what each recorded action and changed field is called on the page.
 * The keys are the server's (backend resources/staffActions/StaffActions.js); an action or field this
 * panel does not know yet is shown by its key rather than hidden.
 */

/** Each action, in the order the filter offers them. */
export const STAFF_ACTION_LABELS = {
    'doctor.created': 'Created a clinician account',
    'doctor.updated': 'Edited a clinician account',
    'doctor.fullPatientAccess': 'Changed "Always sees all patients"',
    'session.moved': 'Moved a session',
    'session.created': 'Added a session',
    'session.updated': 'Changed a session',
    'session.removed': 'Removed a session',
    'activationCode.limitsChanged': 'Changed an activation code\'s limit or on/off',
};

export const STAFF_ACTIONS = Object.keys(STAFF_ACTION_LABELS);

/** What a changed field is called. Staff fields only - the log never records patient data. */
export const STAFF_LOG_FIELD_LABELS = {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    gmc: 'GMC number',
    doctorSignId: 'Signature (file)',
    hasFullPatientAccess: 'Always sees all patients',
    doctorId: 'Doctor',
    doctorUserId: 'Doctor (user)',
    // A session: its first and last day, and its times - UK time, as staff typed them.
    startDate: 'First day',
    endDate: 'Last day',
    startsAt: 'Starts (UK time)',
    endsAt: 'Ends (UK time)',
    appointmentDuration: 'Appointment length (minutes)',
    priority: 'Priority',
    numberOfUses: 'Limit',
    isActive: 'On/off',
};

/** Calendar dates (YYYY-MM-DD from the server), shown as clinicians read them: DD-MM-YYYY. */
export const STAFF_LOG_DATE_FIELDS = ['startDate', 'endDate'];

/** Yes/no fields shown as On / Off rather than Yes / No. */
export const STAFF_LOG_ON_OFF_FIELDS = ['hasFullPatientAccess', 'isActive'];

/** How many entries one page shows. */
export const STAFF_LOG_LIMIT = 20;

/**
 * The "Who" filter: whose changes, by the role they made them in (the server's actorRole - their role at
 * the time, which may differ from their role now). In the order the filter offers them, after "Everyone".
 * `inSentence`: how the empty list names them ("No staff changes by Admins yet").
 */
export const STAFF_LOG_WHO = [
    { role: ADMIN, label: 'Admins', inSentence: 'Admins' },
    { role: SUPER_ADMIN, label: 'Super admins', inSentence: 'super admins' },
    { role: DOCTOR, label: 'Doctors', inSentence: 'Doctors' },
];
